<template>
  <!-- Панель инструментов -->
  <v-toolbar dense color="blue-lighten-1" rounded="xl">
    <v-btn
      icon
      @click="
        formatText('bold');
        bold = !bold;
      "
      :color="bold ? 'black' : ''"
    >
      <v-icon>mdi-format-bold</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="
        formatText('italic');
        italic = !italic;
      "
      :color="italic ? 'black' : ''"
    >
      <v-icon>mdi-format-italic</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="
        formatText('underline');
        underline = !underline;
      "
      :color="underline ? 'black' : ''"
    >
      <v-icon>mdi-format-underline</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="
        formatText('strikeThrough');
        strikeThrough = !strikeThrough;
      "
      :color="strikeThrough ? 'black' : ''"
    >
      <v-icon>mdi-format-strikethrough</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="
        formatText('heading', { level: 1 });
        heading1 = !heading1;
      "
      :color="heading1 ? 'black' : ''"
    >
      <v-icon>mdi-format-header-1</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="
        formatText('heading', { level: 2 });
        heading2 = !heading2;
      "
      :color="heading2 ? 'black' : ''"
    >
      <v-icon>mdi-format-header-2</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="
        formatText('insertUnorderedList');
        insertUnorderedList = !insertUnorderedList;
      "
      :color="insertUnorderedList ? 'black' : ''"
    >
      <v-icon>mdi-format-list-bulleted</v-icon>
    </v-btn>
    <v-btn
      icon
      @click="
        formatText('insertOrderedList');
        insertOrderedList = !insertOrderedList;
      "
      :color="insertOrderedList ? 'black' : ''"
    >
      <v-icon>mdi-format-list-numbered</v-icon>
    </v-btn>
  </v-toolbar>

  <!-- Редактор -->
  <div
    ref="editor"
    contenteditable
    :style="$store.state.isMobile ? ' max-height: 60vh;' : ' max-height: 50vh;'"
    class="editor-content"
    @input="updateContent"
    @click="updateSelection"
    @keyup="updateSelection"
  ></div>
</template>

<script>
export default {
  props: {
    content: String,
  },
  emits: ["update:content"],
  data() {
    return {
      bold: false,
      italic: false,
      underline: false,
      strikeThrough: false,
      heading1: false,
      heading2: false,
      insertUnorderedList: false,
      insertOrderedList: false,

      selection: null, // Сохраняем текущее выделение
    };
  },
  methods: {
    // Форматирование текста
    formatText(command, options = {}) {
      const editor = this.$refs.editor;
      this.restoreSelection(); // Восстанавливаем выделение

      if (command === "heading") {
        const level = options.level || 1;
        document.execCommand("formatBlock", false, `h${level}`);
      } else {
        document.execCommand(command, false, null);
      }

      editor.focus(); // Возвращаем фокус в редактор
      this.updateContent();
    },

    // Сохранение текущего выделения
    updateSelection() {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        this.selection = selection.getRangeAt(0);
      }
    },

    // Восстановление выделения
    restoreSelection() {
      if (this.selection) {
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(this.selection);
      }
    },

    // Обновление содержимого
    updateContent() {
      this.$emit("update:content", this.$refs.editor.innerHTML);
    },
  },
  mounted() {
    this.$refs.editor.innerHTML = this.content;
  },
};
</script>

<style scoped>
.editor-content {
  padding: 16px;
  /* Максимальная высота — 80% высоты экрана */
  min-height: 300px; /* Минимальная высота */
  outline: none;
  width: 100%; /* Ширина блока */
  overflow-y: auto; /* Вертикальный скролл */
  overflow-x: hidden; /* Горизонтальный скролл скрыт */
  box-sizing: border-box; /* Учитываем padding и border в размерах */
  resize: vertical;
}
</style>
